import React from 'react';

type StatusVariant =
  | 'draft' |'ready' |'rendering' |'queued' |'published' |'used' |'unused' |'running' |'idle' |'error' |'warning';

const variantClass: Record<StatusVariant, string> = {
  draft: 'status-draft',
  ready: 'status-ready',
  rendering: 'status-rendering',
  queued: 'status-queued',
  published: 'status-published',
  used: 'status-used',
  unused: 'status-unused',
  running: 'phase-running',
  idle: 'phase-idle',
  error: 'phase-error',
  warning: 'phase-warning',
};

const variantLabel: Record<StatusVariant, string> = {
  draft: 'DRAFT',
  ready: 'READY',
  rendering: 'RENDERING',
  queued: 'QUEUED',
  published: 'PUBLISHED',
  used: 'USED',
  unused: 'UNUSED',
  running: 'RUNNING',
  idle: 'IDLE',
  error: 'ERROR',
  warning: 'WARNING',
};

interface StatusBadgeProps {
  variant: StatusVariant;
  label?: string;
  className?: string;
  dot?: boolean;
}

export default function StatusBadge({ variant, label, className = '', dot = false }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-2xs font-semibold font-mono uppercase tracking-wide ${variantClass[variant]} ${className}`}
    >
      {dot && (
        <span
          className={`w-1.5 h-1.5 rounded-full ${
            variant === 'running' ? 'bg-positive' :
            variant === 'error' ? 'bg-negative' :
            variant === 'warning'? 'bg-warning' : 'bg-current'
          }`}
        />
      )}
      {label ?? variantLabel[variant]}
    </span>
  );
}